// extracted by mini-css-extract-plugin
export default {"rune":"RuneSet_rune__YhzRp","mod":"RuneSet_mod__GP44J RuneSet_rune__YhzRp"};